// pages/monitor/panels/pvc/PvcAlarm.js —— 光储充 · 3.3 故障告警（基准页，三类型复用）
// 今日告警 / 历史告警 + 设备类型·告警等级·状态筛选 + 原文标题列头 AI 翻译。详见 panels/AlarmView.js。
import React from 'react';
import AlarmView from '../AlarmView';

const PvcAlarm = () => <AlarmView />;

export default PvcAlarm;